// Tools
export default {
    getName(element) {
        return element.getAttribute('x-title');
    },

    getXModelValue(element) {
        for (const attribute of element.attributes) {
            if (attribute.name.startsWith('x-model')) {
                return attribute.value;
            }
        }

        return null;
    },
};
